export default "__VITE_ASSET__Cn2Jh0V1__"